import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseURL: 'https://userstock.io/data/',
    tagline: "Free photos of people's faces to use as avatars in UI mockups, prototypes and more.",
    mobileSidebarOpen: false,
  },
  mutations: {
    updateMobileSidebarOpen (state, val) {
      state.mobileSidebarOpen = val
    },
  },
  actions: {

  }
})
